<template>
  <div style="width: 100%;height: 100%">
	<LoginLayout>
		<template>
			<div class="title" style="display: none">{{ info.title }}</div>
			<el-form :model="formObj" ref="form" :rules="rules" style="display: none">
				<el-form-item prop="phone">
					<el-input placeholder="请输入手机号码" prefix-icon="el-icon-user" class="input" maxlength="11" v-model="formObj.phone"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input prefix-icon="el-icon-lock" :type="inputType" placeholder="请输入登录密码" class="input" v-model="formObj.password" @keyup.enter.native="login">
						<img style="width: 15px;margin-right: 5px;margin-top: 20px;" :src="flag?openeye:closeeye" slot="suffix"
                 @click="changePass">
					</el-input>
				</el-form-item>
				<el-form-item>
					<div class="layout dis">
						<el-checkbox v-model="remeber">记住密码</el-checkbox>
						<router-link class="link" to="/forget">忘记密码？</router-link>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button class="btn" type="primary" @click="login">登录</el-button>
				</el-form-item>
				<!-- <el-form-item class="layout last">
					<router-link class="link" to="/register">注册账号</router-link>
				</el-form-item> -->
			</el-form>
<!--			<el-dialog :visible="visible" :show-close="false" :before-close="() => (visible = false)" title="选择企业">-->
<!--				<ul>-->
<!--					<li v-for="item in compList" :key="item.compId" class="item layout">-->
<!--						<span class="">{{ item.compName }}</span>-->
<!--						<el-button type="primary" @click="choose(item)">选择</el-button>-->
<!--					</li>-->
<!--				</ul>-->
<!--			</el-dialog>-->

      <div class="selectCompany" v-if="visible">
        <div class="sc_title">
          <div class="scTitleImg">
            <img src="../../assets/img/selectCompany.png" alt="">
          </div>
          <h2>选择企业</h2>
        </div>
        <div class="sc_content">
          <ul>
            <li style="display: flex;flex: 1;flex-direction: column" v-for="item in compList" :key="item.compId">
              <div class="enterIcon" @click="choose(item)">
                <i class="iconfont icon-xuanze"></i>
              </div>
              <span @click="choose(item)">选择</span>
              <p :title="item.compName">{{ item.compName }}</p>
            </li>
          </ul>
        </div>
      </div>
		</template>
	</LoginLayout>
  <div class="loginmask" v-if="loginmask"></div>
  </div>
</template>

<script>
	import {
		LoginInfo
	} from "@/utils/config";
	import {
		CacheService
	} from "@/service/common";
	import {
		TokenService
	} from "@/service/token";
	import LoginLayout from "@/components/login-layout";
	import userService from "@/apis/userService";
	import compService from "@/apis/compService";
  //import { Message, Loading } from "element-ui"

	export default {
		data() {
			return {
        loginmask:false,
        show:'none',
        companyWidth:'',
        liWidth:'',
        opacity:1,
				flag: false,
				openeye:require('@/assets/img/open-eye.png'),
				closeeye:require('@/assets/img/close-eye.png'),
				inputType:'password',
				info: LoginInfo,
				formObj: {
					phone: "",
					password: "",
				},
				remeber: false,
				rules: {
					phone: [{
						required: true,
						message: "请输入手机号",
						trigger: "blur",
					}, ],
					password: [{
						required: true,
						message: "请输入登录密码",
						trigger: "blur",
					}, ],
				},
				visible: false,
				compList: [],
				userId:0
			};
		},
		mounted() {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
		  // let  loading
      // loading = Loading.service({
      //   //text: 'Loading',
      //   background: 'transparent'
      // })
			const account = CacheService.get("account");
			if (account) {
				this.formObj = { ...account };
				if (account.phone && account.password) {
					this.remeber = true;
				}
			}
      this.getCompList();
		},
		methods: {
			changePass() {
				this.flag = !this.flag;
				this.flag && (this.inputType = 'type')
				!this.flag && (this.inputType = 'password')
			},
			login() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						const {
							phone,
							password
						} = this.formObj;
						userService.login({
							phone: phone,
							passWord: password,
							loginDevice:1
						}).then((res) => {
							const {
								refreshToken,
								accessToken,
								refreshTokenExpired,
								code,
								message,
							} = res;
							if (code === 200) {
								let obj = {
									refreshToken,
									accessToken,
									refreshTokenExpired,
								};
								this.userId = res.userId;
								this.axios.defaults.headers.common.Authorization = `Bearer ${res.accessToken}`;
								TokenService.set(obj);
								CacheService.set("account", {
									phone: this.formObj.phone,
									password: this.remeber ? this.formObj.password : "",
								});
								this.getCompList();
								// userService.getInfo(this.formObj.phone).then((res) => {
								// 	if (res) {
								// 		CacheService.set("user", res);
								// 		this.$store.commit("setUser", res);
								// 	}
								// });
							} else {
								this.$message.error(message);
							}
						});
					}
				});
			},
			getCompList() {
				compService.getUserComp().then((res) => {
					if (res.length) {
						this.visible = true;
						this.compList = res;
            this.$store.commit("setCompList", res);
					} else {
						return this.$message.error('该账号没有注册企业');
					}
				});
			},
			choose(item) {
				if(!(item.compLevel >= 2)) {
						return this.$message.error('该企业还未认证，请先进行认证');
				}
				this.loginmask = true;
				this.$axios.get(`/Yunos/User/ChangeComp?compId=${item.compId}`).then(r => {
					this.$axios.get(`/Yunos/Employee/CompEmployeeInfo`).then(res => {
						if(!res.isAdminRole) {
              this.loginmask = false;
							return this.$message.error('没有权限！');
						}
						CacheService.set("user", res);
						this.$store.commit("setUser", {data: res});
						CacheService.set("comp", item);
						this.$store.commit('setComp', {data: item});
            this.$router.push("/Inside-enterprise");
					})
				})

			},
		},
		components: {
			LoginLayout,
		},
	};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/global.scss";
  li {
    list-style: none;
  }

  .loginmask{
    background: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2002;
    right: 0;
    top: 0;
  }
	.wrap {
		height: 100%;
		background: #f0f2f5;
		font-size: 14px;

		.box {
			width: 900px;
			height: 600px;
			justify-content: center;
			align-items: center;
			background: #fff;
			padding: 20px;
			border-radius: 4px;

      .selectCompany {
        box-sizing: border-box;
        max-width: 870px;
        background: #ffffff;
        border-radius: 23px;
        padding: 40px;
        transition: all .5s;
        .sc_title {
          display: flex;
          .scTitleImg {
            img {
              width: 33px;
              height: 33px;
              margin-right: 13px;
            }
          }

          h2 {
            width: 88px;
            height: 33px;
            font-size: 22px;
            font-weight: 700;
            color: #283062;
          }
        }

        .sc_content {
          margin-top: 40px;
          ul {
            display: flex;
            flex-wrap: wrap;
            height: 192px;
            overflow: auto;
            max-width: 790px;
            li {
              padding: 0 20px;
              min-width: 240px;
              box-sizing: border-box;
              height: 172px;
              border: 1px solid #7694ff;
              border-radius: 12px;
              margin-right: 20px;
              margin-bottom: 20px;
              text-align: center;
              &:nth-child(3n+0){
                margin-right: 0;
              }

              &:last-child {
                margin-right: 0;
              }

              &:hover {
                background: #4581f4;
                .enterIcon {
                  background:white;
                  i {
                    color: #155de8;
                  }
                }

                span {
                  color: white;
                }

                p {
                  color: white;
                }
              }
              .enterIcon {
                width: 55px;
                height: 55px;
                background: #ebf0fe;
                border-radius: 50%;
                margin: 18px auto 12px;
                cursor: pointer;
                i {
                  display: inline-block;
                  vertical-align: -21px;
                  font-size: 22px;
                  color: #7694ff;
                }
              }

              span {
                font-size: 14px;
                color: #7694ff;
                cursor: pointer;
              }

              p {
                text-align: center;
                height: 52px;
                font-size: 14px;
                font-weight: 600;
                color: #666666;
                line-height: 26px;
                margin-top: 10px;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }
          }
        }
      }

			.left {
				flex: 2;
			}

			.right {
				flex: 3;
				padding: 120px;

				.title {
					color: $content_color;
					font-size: 24px;
					margin-bottom: 30px;
					line-height: 33px;
				}

				.input {
					line-height: 50px;

					::v-deep  input {
						line-height: 50px;
						height: 50px;
						padding-left: 40px;
					}

					::v-deep  .el-input__prefix {
						font-size: 20px;
					}
				}

				.dis {
					justify-content: space-between;
				}

				.link {
					color: #1890ff;
					text-decoration: none;
				}

				.btn {
					width: 100%;
					height: 50px;
					font-size: 20px;
				}

				.last {
					justify-content: flex-end;
				}
			}
		}

		.item {
			justify-content: space-between;
			align-items: center;
			padding: 10px;

			&:hover {
				background-color: rgba(64, 158, 255, 0.1);
			}
		}
	}


</style>
